// Shared Israeli mobile-phone / national-ID helpers for the Population
// Management forms. Extracted verbatim from the per-section duplicates
// (PopulationSection / FamilySection / EmergencySection / UserNewModal) so the
// behaviour is unchanged; the `|| ''` guards make the undefined case return
// false/'' instead of throwing (matching UserNewModal's prior guard).

export const normalizePhone = (v: string): string => {
  const stripped = (v || '').replace(/-/g, '')
  return /^0\d{9}$/.test(stripped) ? '+972' + stripped.slice(1) : stripped
}

export const displayPhone = (v: string): string => {
  const raw = v?.startsWith('+972') ? '0' + v.slice(4) : (v || '')
  return raw.length >= 4 ? raw.slice(0, 3) + '-' + raw.slice(3) : raw
}

export const validateIsraeliPhone = (phone: string): boolean => {
  const stripped = (phone || '').replace(/-/g, '')
  return /^\+972\d{9}$/.test(stripped) || /^0\d{9}$/.test(stripped)
}

export const validateIsraeliId = (id: string): boolean => {
  if (!/^\d{9}$/.test(id)) return false
  let sum = 0
  for (let i = 0; i < 9; i++) {
    let digit = parseInt(id[i]) * ((i % 2) + 1)
    if (digit > 9) digit -= 9
    sum += digit
  }
  return sum % 10 === 0
}
